
<form [formGroup]="comboForm">
  <kendo-floatinglabel text="{{label}}">
    <kendo-dropdownlist #combo
                        formControlName="comboValue"
                        [data]="data"
                        [textField]="'Text'"
                        [valueField]="'Value'"
                        (selectionChange)="selectionChange($event)">
    </kendo-dropdownlist>
  </kendo-floatinglabel>
</form>
